export default () => {
	let mainPage = document.querySelector('.card') ? true : false;
	let programList;
	if (mainPage) {
		programList = document.querySelectorAll('.card');
		programList.forEach((program) => {
			program.addEventListener('click', (e) => {
				e.preventDefault()
				let popup = document.querySelector('.schedule-popup')
				popup.style.opacity = '1'
				popup.style.zIndex = '5000'

				let item = '.card';

				let img = e.currentTarget.querySelector(item + '__full-img_img')
					? e.currentTarget.querySelector(item + '__full-img_img').src
					: null
				let title = e.currentTarget.querySelector(item + '__title').innerText
				let age = e.currentTarget.querySelector(item + '__age').innerText
				let year = e.currentTarget.querySelector(item + '__year').innerText
				let genre = e.currentTarget.querySelector(item + '__short-descr')
					? e.currentTarget.querySelector(item + '__short-descr').innerText
					: ''
				let tag = e.currentTarget.querySelector(item + '__genre')
				let text = e.currentTarget.querySelector(item + '__text')
					? e.currentTarget.querySelector(item + '__text').innerText
					: ''

				img
					? (() => {
						popup.querySelector('.schedule-popup__img').src = img
						popup.querySelector('.schedule-popup__img').style.display = 'block'
					})()
					: (popup.querySelector('.schedule-popup__img').style.display = 'none')
				popup.querySelector('.schedule-popup__title').innerHTML = title
				popup.querySelector('.schedule-popup__age').innerHTML = age
				popup.querySelector('.schedule-popup__year').innerHTML = year
				popup.querySelector('.schedule-popup__genre').innerHTML = genre
				popup.querySelector('.schedule-popup__tag').innerHTML = tag.innerHTML
				popup.querySelector('.schedule-popup__tag').style.backgroundImage = localStorage.getItem(tag.innerText.toLowerCase())
				popup.querySelector('.schedule-popup__text').innerHTML = text
				popup.querySelector('.schedule-popup__overlay').style.backgroundImage = window.getComputedStyle(e.currentTarget.querySelector('.card__right')).backgroundImage
				popup.addEventListener('click', (e) => {
					e.stopPropagation()
					e.preventDefault()
					if (
						e.target.classList.contains('container') ||
						e.target.classList.contains('schedule-popup') ||
						e.target.classList.contains('schedule-popup__close')
					) {
						popup.style.opacity = '0'
						setTimeout(() => {
							popup.style.zIndex = '-5000'
						}, 300)
					}
				})
			})
		})
	}
}
